import type { NodeProps } from '@xyflow/react';
import { memo } from 'react';
import { useDiagramViewStore } from '../../store/useDiagramViewStore';
import { useThemeStore } from '../../store/useThemeStore';

export interface GroupNodeData {
  name: string;
  color?: string;
  isSelected?: boolean;
  [key: string]: unknown;
}

function GroupNode({ id, data }: NodeProps & { data: GroupNodeData }) {
  const color = data.color ?? '#6366f1';
  const theme = useThemeStore((s) => s.theme);
  const bgAlpha = theme === 'dark' ? '3d' : '26';
  // During the guided story, groups that are not part of the current step fade back.
  const dimmed = useDiagramViewStore((s) => !!s.tourFocus && !s.tourFocus.nodeIds.has(id));

  return (
    <div
      className={`h-full w-full rounded-xl outline-none ${
        data.isSelected ? 'border-[3px] border-solid' : 'border-2 border-dashed'
      }`}
      style={{
        opacity: dimmed ? 0.3 : 1,
        transition: 'opacity 500ms',
        borderColor: color,
        background: `${color}${bgAlpha}`,
        boxShadow: data.isSelected ? `0 0 0 3px ${color}4d, 0 8px 20px ${color}45` : undefined,
      }}
    >
      <div className="px-3 py-1.5 text-xs font-semibold uppercase tracking-wide" style={{ color }}>
        {data.name}
      </div>
    </div>
  );
}

export default memo(GroupNode);
